export const ALL_ACCOUNTS = "All Accounts"
export const All = "All"
export const BUILDINGS_ACCOUNTS_LIMIT = 50
